import {createRef, useState} from "react"
import {Modal} from "antd"

export default function SdmaModal({name, buttonClass = "", buttonId = "", modalClass = "",
	modalId = "", footer = null, onClose = null, children}) {

	const [show, setShow] = useState(false)

	const close = () => {
		onClose?.()
		setShow(false)
	}

	return (
		<div>
			<button className={`ant-btn ${buttonClass}`} onClick={() => setShow(true)} id={buttonId}>
				{name}
			</button>
			<Modal
				visible={show}
				footer={footer}
				onClose={close}
				onCancel={close}
				width={"100vw"}
				height={"100vh"}
				id={modalId}
				title={name}
				className={modalClass}
			>
				{children}
			</Modal>
		</div>
	)
}
